export const prescriptionDurationChartConfig = {
  title: {
    text: '',
  },
  xAxis: {
    tickWidth: 0,
  },
  yAxis: {
    min: 0,
    max: 100,
    tickPositions: [],
  },
  lang: {
    noData: 'No data available',
  },
  credits: {
    enabled: false,
  },
  chart: {
    type: 'solidgauge',
    spacing: 0,
    renderTo: '',
    styledMode: true,
  },
  tooltip: {
    enabled: false,
  },
  pane: {
    startAngle: 0,
    endAngle: 360,
    size: 74,
    background: [
      {
        // Track for Move
        outerRadius: 40,
        innerRadius: 34,
      },
      {
        outerRadius: 34,
        innerRadius: 0,
      },
    ],
  },
  plotOptions: {
    solidgauge: {
      dataLabels: {
        enabled: true,
        y: -25,
        format:
          '<div class="prescription-chart-label"><span class="label-large">{point.x}</span>' +
          '<br/>{series.name}</div>',
        useHTML: true,
      },
      linecap: 'square',
      stickyTracking: false,
    },
  },
};
